import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AgreementModule } from "@bca-agreement/agreement.module";
import { CompanyDataModule } from "@bca-company-data/company-data.module";
import { ComposeModule } from "@bca-compose/compose.module";
import { ConfirmationModule } from "@bca-confirmation/confirmation.module";
import { ReceiptModule } from "@bca-receipt/receipt.module";
import { ProductInfoModule } from "@bca-shared/modules/product-info/product-info.module";
import { UspBlockModule } from "@bca-shared/modules/usp-block/usp-block.module";
import { SharedModule } from "@bca-shared/shared.module";
import { UserDataModule } from "@bca-user-data/user-data.module";
import { VerifyModule } from "@bca-verify/verify.module";
import { TranslateModule } from "@ngx-translate/core";
import { TabComponent } from "./bca-flow-window/tab-stepper/tab/tab.component";
import { TabStepperComponent } from "./bca-flow-window/tab-stepper/tab-stepper.component";
import { BcaFlowWindowComponent } from "./bca-flow-window/bca-flow-window.component";
import { InfoHeaderComponent } from "./bca-flow-window/info-header/info-header.component";

@NgModule({
  declarations: [
    TabComponent,
    TabStepperComponent,
    BcaFlowWindowComponent,
    InfoHeaderComponent
  ],
  imports: [
    CommonModule,
    ReceiptModule,
    UserDataModule,
    CompanyDataModule,
    VerifyModule,
    AgreementModule,
    ProductInfoModule,
    UspBlockModule,
    ComposeModule,
    ConfirmationModule,
    SharedModule,
    TranslateModule.forChild(),
  ],
  exports: [BcaFlowWindowComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BcaFlowModule {}
